import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { paths } from "helpers/paths";
import { BooleanColumnFilter, rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";

export class CustomPoints extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                sortable: true,
                Cell: ({ value, row: { original } }) => {
                    return <Link to={paths.customPointsShow(original.id)}>{value}</Link>;
                },
            },
            {
                Header: "Период ожидания",
                accessor: "planStayPeriod",
                filterable: true,
                filterType: "int",
                sortable: true,
            },
            {
                Header: "Необязательное посещение",
                accessor: "isVisitOptional",
                filterable: true,
                filterType: "boolean",
                sortable: true,
                Filter: (props) => {
                    const defaultValue = { id: "isVisitOptional", value: "all", filterType: "boolean" };
                    const options = [
                        { label: "Показать все", value: "all" },
                        { label: "Необязательное посещение", value: "true" },
                        { label: "Обязательное посещение", value: "false" },
                    ];
                    return <BooleanColumnFilter {...props} options={options} defaultValue={defaultValue} />;
                },
                Cell: ({ value }) => (value ? "Необязательное посещение" : "Обязательное посещение"),
            },
        ];
    }

    renderActions() {
        return (
            <div className="d-flex align-items-center justify-content-between">
                {super.renderActions()}
                <Link to={paths.itemChangePoints} className="link small">
                    Адреса перецепок
                </Link>
            </div>
        );
    }

    renderListComponent = () => {
        return <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
    };

    renderCreateButton = () => {
        const { modal, mergeParams } = this.props;
        const action = () =>
            modal({
                name: "createCustomPoint",
                title: "Создание точки",
                windowMod: "wide",
                mergeParams,
            });
        return (
            <a className="btn btn-brand btn-sm" onClick={action}>
                Создать точку
            </a>
        );
    };
}

export default tableContainer(CustomPoints, "custompoints");
